export class ListMPARequestsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListMPARequestsRequestFilters",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<ListMPARequestsSort>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMPARequestsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
